import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ReportsService } from './reportsApi';
import { IPaginationPayload } from '../../../interfaces/shared/IPaginationPayload';
import { AxiosError } from 'axios';

const initialState: any = {
    reportsAreLoading: false,
    reportIsLoading: false,
    requestStatus: 'default',
    message: '',
};

export const tryToFetchReports = createAsyncThunk<any, IPaginationPayload>(
    'reports/tryToFetchReports',
    async ({ pageNumber, pageSize, filters, data }) => {
        const result = await ReportsService.tryToFetchReports(
            pageNumber,
            pageSize,
            data,
            filters,
        );
        return result?.data;
    },
);

export const tryToFetchQualityReport = createAsyncThunk<any, any>(
    'reports/tryToFetchQualityReport',
    async (data: any) => {
        const result = await ReportsService.tryToFetchQualityReport(data);
        return result?.data;
    }
);

export const tryToFetchSingleReport = createAsyncThunk<any, any>(
    'reports/tryToFetchSingleReport',
    async (id: string) => {
        const result = await ReportsService.tryToFetchSingleReport(id);
        return result?.data;
    }
);

export const tryToFetchTripTopics = createAsyncThunk<any, void>(
    'reports/tryToFetchTripTopics',
    async () => {
        const result = await ReportsService.tryToFetchTripTopics();
        return result?.data?.data;
    }
);

export const tryToSignoffReport = createAsyncThunk<any, any>(
    'reports/tryToSignoffReport',
    async (data, { rejectWithValue }) => {
        try {
            const result = await ReportsService.tryToSignoffReport(data);
            return result.data;
        } catch (error) {
            const err: any = error as AxiosError;
            return rejectWithValue(err?.response?.data?.message);
        }
    },
);

export const reportsSlice = createSlice({
    name: 'reports',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // tryToFetchReports
            .addCase(tryToFetchReports.pending, (state) => {
                state.reportsAreLoading = true;
            })
            .addCase(tryToFetchReports.rejected, (state) => {
                state.reportsAreLoading = false;
            })
            .addCase(tryToFetchReports.fulfilled, (state, action) => {
                state.reportsAreLoading = false;
                state.reports = action.payload;
            })

            // tryToFetchSingleReport
            .addCase(tryToFetchSingleReport.pending, (state) => {
                state.reportIsLoading = true;
            })
            .addCase(tryToFetchSingleReport.rejected, (state) => {
                state.reportIsLoading = false;
            })
            .addCase(tryToFetchSingleReport.fulfilled, (state, action) => {
                state.reportIsLoading = false;
                state.report = action.payload;
            })

            // tryToFetchQualityReport
            .addCase(tryToFetchQualityReport.pending, (state) => {
                state.reportsAreLoading = true;
            })
            .addCase(tryToFetchQualityReport.rejected, (state) => {
                state.reportsAreLoading = false;
            })
            .addCase(tryToFetchQualityReport.fulfilled, (state, action) => {
                state.reportsAreLoading = false;
                state.qualityReport = action.payload;
            })

    },
});

export default reportsSlice.reducer;